import { FinancialJuiceWidget } from './FinancialJuiceWidget';

interface FJVoiceWidgetProps {
  onRemove: () => void;
}

export function FJVoiceWidget({ onRemove }: FJVoiceWidgetProps) {
  return (
    <FinancialJuiceWidget
      widgetType="Voice"
      mode="inline"
      title="Voice Squawk"
      onRemove={onRemove}
    />
  );
}
